import React from "react";

import AccountTreeIcon from "@mui/icons-material/AccountTree";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import BuildIcon from "@mui/icons-material/Build";
import DataObjectIcon from "@mui/icons-material/DataObject";
import DomainIcon from "@mui/icons-material/Domain";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import SchoolIcon from "@mui/icons-material/School";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import StorageIcon from "@mui/icons-material/Storage";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";

import DisplayPrivilegeIcon from "components/shared/display-privilege-icon";

export const VALID_PRIVILEGES_DISPLAY = [
  "manage_role",
  "manage_users",
  "create_children",
  "billing",
  "manage_data",
  "allow_modify_manage_data",
  "allow_mobile_data_access_sync",
  "create_template",
  "manage_assets",
  "manage_training",
];

export const showPrivilegeIcons = (privEntries: { [key: string]: boolean }) => {
  // Filter the valid list by the actual assigned privileges, this guarantees the same sort order as VALID_PRIVILEGES_DISPLAY.
  const privileges = VALID_PRIVILEGES_DISPLAY.filter((privilege) => {
    return privEntries[privilege];
  });

  return privileges.map((privilege) => {
    return <DisplayPrivilegeIcon key={privilege} privilegeName={privilege} />;
  });
};

export const privilegeDisplays = [
  {
    privilege: "manage_role",
    privilegeName: "Admin Permissions",
    iconColour: "#286090",
    component: (
      <DomainIcon
        fontSize="small"
        style={{ marginLeft: "2px" }}
        data-testid={"admin-icon"}
      />
    ),
  },
  {
    privilege: "create_children",
    privilegeName: "Groups Permission",
    iconColour: "#31b0d5",
    component: (
      <AccountTreeIcon
        fontSize="small"
        data-testid={"groups-privileges-icon"}
      />
    ),
  },
  {
    privilege: "billing",
    privilegeName: "Billing Permissions",
    iconColour: "#449d44",
    component: (
      <AttachMoneyIcon
        fontSize="small"
        data-testid={"billing-privileges-icon"}
      />
    ),
  },
  {
    privilege: "manage_users",
    privilegeName: "Users Permissions",
    iconColour: "#ec971f",
    component: (
      <SupervisorAccountIcon
        fontSize="small"
        data-testid={"users-privileges-icon"}
      />
    ),
  },
  {
    privilege: "manage_data",
    privilegeName: "Data Access",
    iconColour: "#e6e6e6",
    component: (
      <StorageIcon
        fontSize="small"
        style={{ color: "black" }}
        data-testid={"data-access-privileges-icon"}
      />
    ),
  },
  {
    privilege: "allow_modify_manage_data",
    privilegeName: "Manage Data",
    iconColour: "#e6e6e6",
    component: (
      <DataObjectIcon
        fontSize="small"
        style={{ color: "black" }}
        data-testid={"allow-modify-manage-data-privileges-icon"}
      />
    ),
  },
  {
    privilege: "allow_mobile_data_access_sync",
    privilegeName: "Mobile Data Access",
    iconColour: "#d9534f",
    component: (
      <SmartphoneIcon
        fontSize="small"
        data-testid={"mobile-access-data-privileges-icon"}
      />
    ),
  },
  {
    privilege: "create_template",
    privilegeName: "Create Template",
    iconColour: "#6559FF",
    component: (
      <NoteAddIcon
        fontSize="small"
        data-testid={"create-template-privileges-icon"}
      />
    ),
  },
  {
    privilege: "create_template",
    privilegeName: "Create Template",
    iconColour: "#6559FF",
    component: (
      <NoteAddIcon
        fontSize="small"
        data-testid={"create-template-privileges-icon"}
      />
    ),
  },
  {
    privilege: "manage_assets",
    privilegeName: "Manage Assets",
    iconColour: "#aa59ff",
    component: (
      <BuildIcon
        fontSize="small"
        data-testid={"manage-assets-privileges-icon"}
      />
    ),
  },
  {
    privilege: "manage_training",
    privilegeName: "Manage Training",
    iconColour: "#285ca1",
    component: (
      <SchoolIcon
        fontSize="small"
        data-testid={"manage-training-privileges-icon"}
      />
    ),
  },
];
